module.exports = __webpack_public_path__ + "e28367a1f8ab84e9762806a13169b793.svg";